import {
  activeTradesComparisonColsOrder,
  getComparisonColumnDefinitions,
} from './comparisonTable.config';

export const getDefaultColumns = (obj: { min: number; max: number }) => {
  const columnMap = new Map(getComparisonColumnDefinitions(obj).map((col) => [col.id, col]));
  return activeTradesComparisonColsOrder
    .map((id) => columnMap.get(id))
    .filter((col) => col !== undefined);
};

export const basisPointsToPercent = (n: number | null) =>
  n || n === 0 ? ((n / 10000 + 1) * 100).toFixed(3) : '';

export const getValueByPath = (obj: any, path: string): any => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};
